export function reconnectDelayMs(consecutiveFailures: number): number {
  const n = Math.max(1, consecutiveFailures);
  return Math.min(3000 * 2 ** (n - 1), 60_000);
}
